export default {
  MAX_WIDTH: 420,
};
